import React from 'react'
import Loader, { LoaderIcon } from '@components/loader'
import {
  DEFAULT_LOADER_ICON,
  LOADER_ICON_CONFIGS
} from './config'
import withConnect from './connector'
import { Props } from './types'
import { Wrapper } from './style'

export const PartnerLoader: React.FC<Props> = ({
  className,
  iconClassName,
  partner,
  size,
  variant
}: Props) => {
  const partnerIcon = LOADER_ICON_CONFIGS[partner] ?? DEFAULT_LOADER_ICON
  const sizeString = size !== undefined ? `${size.toString()}px` : undefined

  return (
    <Wrapper className={className}>
      <Loader
        className={iconClassName}
        height={sizeString}
        icon={partnerIcon as LoaderIcon}
        variant={variant}
        width={sizeString}
      />
    </Wrapper>
  )
}

export default withConnect(PartnerLoader)
